/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const CustomComparisonOptions = {
  custom: {
    'conversation.tag_ids': {
      optionalSelect: {
        comparison: [{
          label: 'has any value',
          value: 'known'
        }, {
          label: 'is',
          value: 'eq'
        }]
      }
    },
    'rules_filters.assign_to': {
      optionalSelect: {
        comparison: [{
          label: 'has any value',
          value: 'known'
        }, {
          label: 'is',
          value: 'eq'
        }]
      }
    },
    'rules_filters.mark_priority': {
      boolean: {
        comparison: [{
          label: 'is present',
          value: 'true'
        }]
      }
    },
    'rules_filters.apply_conversation_sla': {
      optionalSelect: {
        comparison: [{
          label: 'has any value',
          value: 'known'
        }, {
          label: 'is',
          value: 'eq'
        }]
      }
    },
    'message.outbound_from_inbox': {
      boolean: {
        comparison: [{
          label: 'is present',
          value: 'true'
        }]
      }
    }
  }
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;